module.exports = __webpack_public_path__ + "static/media/WU_PAYMENT_cash_active.6690784c.svg";